<template>
    <div class="ji_fen">
        <div class="top_bar">
            <div class="tab_box">
                <div class="tab_item" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active_tab' : '' " @click="TabClick(item, index)" >
                    {{ item }}
                </div>
            </div>
            <div class="btn_box">
                <el-select v-model="type" placeholder="问责" style="width:165px;height:35px;margin: 0 10px;" @chnage="typeChange">
                    <el-option
                    
                    v-for="item in typeList"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue">
                    </el-option>
                </el-select>
            </div>
        </div>

        <div class="list_box" v-if="list && list.length">
            <div class="list_item" v-for="(item, index) in list" :key="index" @click="ShowDetail( item )">
                <!-- <div class="icon_box">
                        <span class="iconfont icon-icon02"></span>
                </div> -->
                <div class="left_box">
                    
                    <div class="tops">
                        <span class="iconfont icon-w_jiangli-" v-if="item.type == 1"></span>
                        <span class="iconfont icon-zerenren" v-if="item.type == 2"></span>
                        <span class="iconfont icon-weijichufentongji" v-if="item.type == 3"></span>
                        <span class="iconfont icon-kunnanshengrenyuanmingdan" v-if="item.type == 4"></span>
                        <span class="iconfont icon-shilianyujing" v-if="item.type == 5"></span>

                        <div class="tag">【{{ item.typeName }}】</div>
                        <div class="title">{{ item.reason }}</div>
                    </div>
                    <div class="time">
                       <span class="iconfont icon-shijian"></span> {{ item.createTime }}
                    </div>
                </div>
                <div class="right_box">
                    <span class="iconfont icon-jiantouyou"></span>
                </div>
            </div>
            <div class="page_box" v-if="list && list.length">
                <el-pagination
                background
                layout="prev, pager, next"
                :current-page="page"
                :current-change="pageChange"
                :page-size="10"
                :total="totalPage * 10">
                </el-pagination>
            </div>
        </div>

        <div class="noMore" v-else>
            <img src="../../assets/static/index/nomore.png" alt="">
        </div>

        <!-- 申报dialog -->
        <div class="dialog_model" v-if="ShenBaoDialogShow">
            <div class="dialog_box">
                <div class="dialog_title">
                   <span> {{ formData.typeName }}详情</span>
                   <span class="el-icon-close" style="cursor: pointer;" @click="cancelShenBao"></span>
                </div>
                <!-- 处分 -->
                <div class="form_box" v-if="formData.type == 0">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="党员姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="处分原因" prop="pass">
                            <el-input type="text" v-model="formData.reason" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="处分机构" prop="pass">
                            <el-input type="text" v-model="formData.organ" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="处分时间" prop="pass">
                            <el-input type="text" v-model="formData.punishTime" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="处分结果" prop="pass" >
                            <el-input type="text" v-model="formData.result" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <!-- <el-button class="sub_btn" @click="submitFor" v-if="!formData.id">提交</el-button> -->
                            <!-- <el-button class="cel_btn" @click="cancelShenBao">取消</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 问责 -->
                <div class="form_box" v-if="formData.type == 1">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="党员姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="问责原因" prop="pass">
                            <el-input type="text" v-model="formData.reason" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="问责机构" prop="pass">
                            <el-input type="text" v-model="formData.organ" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="问责时间" prop="pass">
                            <el-input type="text" v-model="formData.punishTime" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="问责结果" prop="pass" >
                            <el-input type="text" v-model="formData.result" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <!-- <el-button class="sub_btn" @click="submitFor" v-if="!formData.id">提交</el-button> -->
                            <!-- <el-button class="cel_btn" @click="cancelShenBao">取消</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 问责 -->
                <div class="form_box" v-if="formData.type == 2">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="党员姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="奖励日期" prop="pass">
                            <el-input type="text" v-model="formData.punishTime" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="奖励内容" prop="pass">
                            <el-input type="text" v-model="formData.reason" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="奖励机构" prop="pass">
                            <el-input type="text" v-model="formData.organ" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="奖励等级" prop="pass" >
                            <el-input type="text" v-model="formData.organRank" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <!-- <el-button class="sub_btn" @click="submitFor" v-if="!formData.id">提交</el-button> -->
                            <!-- <el-button class="cel_btn" @click="cancelShenBao">取消</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 失联 -->
                <div class="form_box" v-if="formData.type == 3">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="党员姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="登记日期" prop="pass">
                            <el-input type="text" v-model="formData.punishTime" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="是否失联" prop="pass">
                            <el-input type="text" v-model="formData.ext04" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <!-- <el-button class="sub_btn" @click="submitFor" v-if="!formData.id">提交</el-button> -->
                            <!-- <el-button class="cel_btn" @click="cancelShenBao">取消</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 困难 -->
                <div class="form_box" v-if="formData.type == 4">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="党员姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="登记日期" prop="pass">
                            <el-input type="text" v-model="formData.punishTime" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="是否困难" prop="pass">
                            <el-input type="text" v-model="formData.ext04" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <!-- <el-button class="sub_btn" @click="submitFor" v-if="!formData.id">提交</el-button> -->
                            
                        </el-form-item>
                    </el-form>
                    
                </div>
                    <div class="btns_box">
                        <el-button class="cel_btn" @click="cancelShenBao">取消</el-button>
                    </div>

            </div>
        </div>

     

    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TabList: ["党员业务"],
                TabCur: 0,
                list: [

                ],
                
                ShenBaoDialogShow: false,
                formData: {
                   
                },
                dialogImageUrl: '',
                dialogVisible: false,
                type: "",
                month: "",
                page: 1,
                totalPage: 0,
                typeList: [],
                
            }
        },
        computed: {
            ...mapGetters(["token"])
        },
        mounted () {
            this.getList();
            this.getTypeList()
        },
        watch: {
            type () {
                // console.log( this.type )
                this.page = 1
                this.getList()
            }
        },
        methods: {
            // 展示业务详情
            async ShowDetail ( item ) {
                let { token } = this 
                let { id } = item
                let res = await this.$axios.post("/lencon/pc/person/user_punish_detail", { token, id  })
                if ( res.data.code == 1 ) {
                    this.formData = res.data.obj
                    this.ShenBaoDialogShow = true
                }
            },
            // 点击tab
            TabClick(item, index) {
                this.TabCur = index
            },
            // 类型变化
            typeChange ( e ) {
                console.log( e )
            },
            // 点击积分申报
            ShenBao () {
                this.ShenBaoDialogShow = true
            },
            // 取消申报
            cancelShenBao () {
                this.ShenBaoDialogShow = false
            },  
            // 获取业务列表
            async getList () {
                this.list = []
                let { token, page, type } = this
                if ( !type ) {
                    type = 1
                }
                let res = await this.$axios.post("/lencon/pc/person/user_punish", { token, page, type: Number( type ) })
                if ( res.data.code == 1 ) {
                    this.list = res.data.res
                    this.totalPage = res.data.totalPages
                }
            },
            // 页码变化
            pageChange ( page ) {
                this.page = page 
                this.getList()
            },
            // 获取业务类型
            async getTypeList () {
                let res = await this.$axios.post("/lencon/pc/common/dataList", { type: "bus_punish_type" })
                if ( res.data.code == 1 ) {
                    this.typeList = res.data.res
                }
            }
        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
}
.elSelect {
    width: 165px;
    height: 35px;
    margin: 0 10px;
}
</style>


<style lang="scss" scoped>
.btns_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
}
.ji_fen {
    width: 980px;
    padding: 20px;
    box-sizing: border-box;
    .top_bar {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom:1px solid #eeeeee;
        .tab_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            .tab_item {
                width: 120px;
                text-align: center;
                padding-bottom: 10px;
                cursor: pointer;
            }
            .active_tab {
                color: #2767c4 ;
                border-bottom: 2px solid #2767c4 ;
            }
        }
        .btn_box {
            .study_btn {
                background: #EEEEEE;
                border-radius: 5px;
            }
            .shenbao_btn {
                background: #2767c4 ;
                border-radius: 5px;
                color: #fff;
            }
        }
    }
    .list_box {
        width: 100%;
        .list_item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 30px 0;
            border-bottom: 1px dashed #eeeeee;
            padding-bottom: 30px;
            font-size: 18px;
            cursor: pointer;
            .icon_box {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                overflow: hidden;
                background-color: #2767c4 ;
                text-align: center;
                line-height: 44px;
                .iconfont {
                    color: #fff;
                    font-size: 26px;
                }
            }
            .left_box {
                // display: flex;
                // align-items: center;
                flex: 1;
                .tops {
                    display: flex;
                    align-items: center;
                    .title {
                        width: 600px;
                        overflow: hidden;
                    }
                    .tag {
                        font-weight: bold;
                        color: #2767c4 ;
                    }
                    .iconfont {
                        font-size: 20px;
                        color: #2767c4 ;
                    }
                }
                .time {
                    font-size: 14px;
                    color: #BEBEBE;
                    // margin-left: 10px;
                    line-height: 30px;
                }
                
            }
            .right_box {
                width:150px;
                text-align: right;
            }
        }
        .page_box {
            text-align: right;
        }
    }

    .dialog_model {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1000;
        background-color: rgba(0,0,0,.3);
        .dialog_box {
            width: 820px;
            height: 735px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -410px;
            margin-top: -377px;
            background-color: #fff;
            border-radius: 5px;
            overflow: hidden;
            padding: 20px;
            .dialog_title {
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 2px solid #2767c4 ;
                color: #2767c4 ;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .form_box {
                padding: 20px 0;
                .sub_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #2767c4 ;
                }
                .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
            }
        }
    }
}
</style>